import styled, { css } from 'styled-components'

interface H1Props {
  color?: string
}

interface H2Props {
  color?: string
  grey?: boolean
}

interface H3Props {
  clickable?: () => void
  noMargin?: boolean
}

interface PProps {
  noMargin?: boolean
}

interface SpanProps {
  light?: boolean
  small?: boolean
  grey?: boolean
  bold?: boolean
  overflowEllipsis?: boolean
  extraSmall?: boolean
}

export const H1 = styled.h1<H1Props>`
  ${({ color, theme: { colors } }) => css`
    &&& {
      color: ${color ?? colors.abyss};
      font-size: 20px;
      font-weight: 400;
      margin-top: 0;
      margin-bottom: 16px;
    }
  `}
`

export const H2 = styled.h2<H2Props>`
  ${({ theme: { colors }, grey }) => css`
    &&& {
      color: ${grey ? colors.textGrey : colors.abyss};
      font-size: 18px;
      font-weight: 400;
      margin-bottom: 8px;
    }
  `}
`

export const H3 = styled.h3<H3Props>`
  ${({ theme: { colors }, clickable, noMargin }) => css`
    &&& {
      cursor: ${clickable ? 'pointer' : 'text'};
      color: ${colors.abyss};
      font-size: 14px;
      /* !important can be removed when all h3 tags have been replaced with this component */
      font-weight: 500 !important;
      margin: ${noMargin ? '0' : 'initial'};
    }
  `}
`

export const P = styled.p<PProps>`
  ${({ theme: { colors }, noMargin }) => css`
    color: ${colors.abyss};
    font-size: 14px;
    margin: ${noMargin ? '0' : '0 0 1em'};
    font-weight: 300;
    line-height: 23px;
    white-space: pre-line;
    word-break: break-word;
  `}
`

export const Span = styled.span<SpanProps>`
  ${({
    theme: { colors },
    light,
    small,
    grey,
    bold,
    overflowEllipsis,
    extraSmall,
  }) => css`
    color: ${grey ? colors.textGrey : colors.abyss};
    font-weight: ${light ? 300 : bold ? 500 : 400};
    font-size: ${extraSmall ? '10px' : small ? '12px' : '14px'};
    white-space: ${overflowEllipsis ? 'nowrap' : 'normal'};
    overflow: ${overflowEllipsis ? 'hidden' : 'visible'};
    text-overflow: ${overflowEllipsis ? 'ellipsis' : 'clip'};
    overflow-wrap: anywhere;
  `}
`
